/* UPDATED EmptyModal.js for REACT 18, Bootstrap 5, Show Photos 06-19-25 */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './EmptyModal.css';

const EmptyModal = ({ modalProps = {}, visible, hideModal }) => {
  const modalRef = useRef(null);

  console.log('EmptyModal rendering with props:', { modalProps, visible, hideModal });

  useEffect(() => {
    console.log('EmptyModal useEffect triggered: visible=', visible);
    const modalElement = modalRef.current;
    if (modalElement) {
      console.log('Modal element found:', modalElement);
      if (visible) {
        console.log('Adding show and d-block to EmptyModal');
        modalElement.classList.add('show', 'd-block');
        modalElement.style.display = 'block';
        modalElement.style.zIndex = '1055';
        document.body.classList.add('modal-open');
        const backdrop = document.createElement('div');
        backdrop.className = 'modal-backdrop fade show';
        backdrop.style.zIndex = '1050';
        document.body.appendChild(backdrop);
        modalElement.addEventListener('click', (e) => {
          if (e.target === modalElement && hideModal) {
            console.log('Backdrop clicked, closing EmptyModal');
            hideModal();
          }
        });
      } else {
        console.log('Removing show and d-block from EmptyModal');
        modalElement.classList.remove('show', 'd-block');
        modalElement.style.display = 'none';
        modalElement.style.zIndex = '';
        document.body.classList.remove('modal-open');
        const existingBackdrop = document.querySelector('.modal-backdrop');
        if (existingBackdrop) {
          console.log('Removing backdrop:', existingBackdrop);
          existingBackdrop.remove();
        }
      }
    } else {
      console.error('Modal element not found; ref=', modalRef.current);
    }
    return () => {
      console.log('EmptyModal useEffect cleanup');
      document.body.classList.remove('modal-open');
      const existingBackdrop = document.querySelector('.modal-backdrop');
      if (existingBackdrop) {
        console.log('Cleanup: Removing backdrop:', existingBackdrop);
        existingBackdrop.remove();
      }
      if (modalElement) {
        modalElement.removeEventListener('click', () => {});
      }
    };
  }, [visible, hideModal]);

  if (!visible) {
    console.log('EmptyModal not visible, returning null');
    return null;
  }

  console.log('Rendering EmptyModal content');

  return (
    <div
      id="empty-modal"
      className="modal fade"
      ref={modalRef}
      tabIndex="-1"
      aria-hidden={!visible}
      style={{
        zIndex: 1055,
        display: visible ? 'block' : 'none',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'transparent'
      }}
    >
      <div
        className="modal-dialog modal-md"
        style={{
          maxWidth: '500px',
          margin: '1.75rem auto',
          position: 'relative',
          top: '20%'
        }}
      >
        <div
          className="modal-content"
          style={{
            backgroundColor: '#ffffff',
            borderRadius: '0.3rem',
            border: '1px solid rgba(0, 0, 0, 0.2)',
            opacity: 1
          }}
        >
          <div
            className="modal-header"
            style={{
              backgroundColor: '#24262D',
              color: '#ffffff',
              padding: '1rem',
              borderBottom: '1px solid #dee2e6'
            }}
          >
            <h5 className="modal-title">Photo Preview</h5>
            <button
              type="button"
              className="btn-close"
              onClick={() => {
                console.log('Empty modal close button clicked');
                if (hideModal) hideModal();
              }}
              aria-label="Close"
            ></button>
          </div>
          <div
            className="modal-body"
            style={{ padding: '1rem', textAlign: 'center', color: '#000000', opacity: 1 }}
          >
            <p>No photos available</p>
          </div>
        </div>
      </div>
    </div>
  );
};

EmptyModal.propTypes = {
  modalProps: PropTypes.object,
  visible: PropTypes.bool.isRequired,
  hideModal: PropTypes.func
};

export default EmptyModal;